import React, { Component } from 'react';
import PropTypes from "prop-types";
import { NoticeContainer } from "../../../../../../../CommonComponents/Info/Notice/styles";
import { NoticeBorder, NoticeContent } from '../styles';

class Notice extends Component {
  render() {
    return (
      <div className="fluid">
      <NoticeBorder>
        <NoticeContainer widthSize="92%"
          message={(
            <NoticeContent className="flex">
              <div>
              <div dangerouslySetInnerHTML={{__html: this.props.message}}></div>
              </div>
            </NoticeContent>
          )}> </NoticeContainer>
      </NoticeBorder>
      </div>
    );
  }
}

Notice.propTypes = {
  message: PropTypes.string
}

export default Notice;
